import { Link } from "react-router-dom";
import { StatusBadge, ConfidenceBadge, kindIcon } from "@/components/StatusBadge";
import { AlertTriangle, Copy } from "lucide-react";

export function FileCard({ f, index = 0 }) {
  return (
    <Link
      to={`/file/${f.id}`}
      data-testid={`file-card-${f.id}`}
      className="group block rounded-xl border border-white/5 bg-[#111827] p-5 hover:bg-[#1a2436] hover:border-white/10 hover:-translate-y-1 transition-transform transition-colors duration-300 fade-up"
      style={{ animationDelay: `${Math.min(index * 40, 400)}ms` }}
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex items-center gap-2 text-blue-400">
          {kindIcon(f.kind, "w-4 h-4")}
          <span className="text-[11px] uppercase tracking-wider text-slate-500 font-mono">{f.kind}</span>
        </div>
        <StatusBadge status={f.status} />
      </div>
      <h3 className="font-display font-semibold text-[15px] text-white leading-snug line-clamp-2 mb-2 group-hover:text-blue-300 transition-colors">
        {f.title}
      </h3>
      <p className="text-sm text-slate-400 line-clamp-2 mb-3 min-h-[2.5rem]">
        {f.executive_summary || f.original_filename}
      </p>
      <div className="flex items-center gap-2 flex-wrap">
        <ConfidenceBadge value={f.confidence} />
        {f.is_duplicate && (
          <span className="inline-flex items-center gap-1 text-[11px] text-amber-400"><Copy className="w-3 h-3" /> duplicate</span>
        )}
        {f.sensitive_flags?.length > 0 && (
          <span className="inline-flex items-center gap-1 text-[11px] text-red-400"><AlertTriangle className="w-3 h-3" /> sensitive</span>
        )}
      </div>
      {f.tags?.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-3">
          {f.tags.slice(0, 3).map((t) => (
            <span key={t} className="text-[11px] px-2 py-0.5 rounded-md bg-white/5 text-slate-300">{t}</span>
          ))}
        </div>
      )}
    </Link>
  );
}
